/* eslint-disable max-lines */
import { FunctionalityEnum } from '@elearning-platform/api-types/enums';

import { RouteGroupName, RouteNameEnum } from '../enums';
import { RouteGroup } from '../interfaces';

// eslint-disable-next-line @typescript-eslint/typedef
export const routingConfig = {
  [RouteGroupName.Base]: {
    urls: {
      pl: '/',
      en: '/',
    },
    children: {
      [RouteNameEnum.IncomingAuth]: {
        urls: {
          pl: '/incoming-auth/:internalToken/:authToken',
          en: '/incoming-auth/:internalToken/:authToken',
        },
        title: 'competence.app.routingConfig.incomingAuth.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ComparisonTable]: {
        urls: {
          pl: '/porownaj-oferty-ubezpieczen',
          en: '/compare-insurance-offers',
        },
        title: 'competence.app.routingConfig.comparisonTable.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ConfirmEmail]: {
        urls: {
          pl: '/confirm-email',
          en: '/confirm-email',
        },
        title: 'competence.app.routingConfig.confirmEmail.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.EmailVerification]: {
        urls: {
          pl: '/email-verification/:token',
          en: '/email-verification/:token',
        },
        title: 'competence.app.routingConfig.emailVerification.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.AnonSurvey]: {
        urls: {
          pl: '/ankieta/:id',
          en: '/ankieta/:id',
        },
        title: 'competence.app.routingConfig.anonSurvey.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.Dashboard]: {
        urls: {
          pl: '/pulpit',
          en: '/pulpit',
        },
        title: 'competence.app.routingConfig.dashboard.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiDashboard,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.Form]: {
        urls: {
          pl: '/formularze/:id',
          en: '/formularze/:id',
        },
        title: 'competence.app.routingConfig.form.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiSurveyInit,
          FunctionalityEnum.ApiSurveySave,
          FunctionalityEnum.ApiSurveySummary,
          FunctionalityEnum.ApiSurveyFinish,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.Idd]: {
        urls: {
          pl: '/idd',
          en: '/idd',
        },
        title: 'competence.app.routingConfig.idd.title',
        secured: true,
        requiredFunctionalities: [
          'api_user_idd_dashboard' as FunctionalityEnum,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.KnowledgeBase]: {
        urls: {
          pl: '/lekcje',
          en: '/lessons',
        },
        title: 'competence.app.routingConfig.knowledgeBase.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiLearningList,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.KnowledgeBaseLesson]: {
        urls: {
          pl: '/lekcje/:id',
          en: '/lessons/:id',
        },
        title: 'competence.app.routingConfig.knowledgeBaseLesson.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiContentInit,
          FunctionalityEnum.ApiContentRelated,
          FunctionalityEnum.ApiContentComments,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.Notifications]: {
        urls: {
          pl: '/powiadomienia',
          en: '/powiadomienia',
        },
        title: 'competence.app.routingConfig.notifications.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiNotificationList,
          FunctionalityEnum.ApiNotificationRead,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.Onboarding]: {
        urls: {
          pl: '/onboarding',
          en: '/onboarding',
        },
        title: 'competence.app.routingConfig.onboarding.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiOnboardingDashboard,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.Surveys]: {
        urls: {
          pl: '/formularze',
          en: '/formularze',
        },
        title: 'competence.app.routingConfig.surveys.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiSurveyList,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.Trainings]: {
        urls: {
          pl: '/szkolenia',
          en: '/szkolenia',
        },
        title: 'competence.app.routingConfig.trainings.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiEventsList,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.TrainingDetails]: {
        urls: {
          pl: '/szkolenia/:id',
          en: '/szkolenia/:id',
        },
        title: 'competence.app.routingConfig.trainingDetails.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiEventsDetails,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.VideoPlayer]: {
        urls: {
          pl: '/wideo/:id',
          en: '/wideo/:id',
        },
        title: 'competence.app.routingConfig.videoPlayer.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiContentInit,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.SignIn]: {
        urls: {
          pl: '/',
          en: '/',
        },
        title: 'competence.app.routingConfig.signIn.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.Registration]: {
        urls: {
          pl: '/registration',
          en: '/registration',
        },
        title: 'competence.app.routingConfig.registration.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.AccountActivation]: {
        urls: {
          pl: '/aktywacja',
          en: '/aktywacja',
        },
        title: 'competence.app.routingConfig.accountActivation.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.RemindPassword]: {
        urls: {
          pl: '/remind-password',
          en: '/remind-password',
        },
        title: 'competence.app.routingConfig.remindPassword.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ContactDataConfirm]: {
        urls: {
          pl: '/weryfikacja-danych-kontaktowych/:token',
          en: '/weryfikacja-danych-kontaktowych/:token',
        },
        title: 'competence.app.routingConfig.contactDataConfirm.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.PreAccountRegistration]: {
        urls: {
          pl: '/registration/:hash',
          en: '/registration/:hash',
        },
        title: 'competence.app.routingConfig.preAccountRegistration.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.Regulations]: {
        urls: {
          pl: '/regulamin',
          en: '/regulamin',
        },
        title: 'competence.app.routingConfig.regulations.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.PrivacyPolicy]: {
        urls: {
          pl: '/polityka-prywatnosci',
          en: '/polityka-prywatnosci',
        },
        title: 'competence.app.routingConfig.privacyPolicy.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.InformationDuty]: {
        urls: {
          pl: '/klauzula-informacyjna',
          en: '/klauzula-informacyjna',
        },
        title: 'competence.app.routingConfig.informationDuty.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.TrainingRegulations]: {
        urls: {
          pl: '/regulamin-szkolen',
          en: '/training-regulations',
        },
        title: 'competence.app.routingConfig.trainingRegulations.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.NotFound]: {
        urls: {
          pl: '/nie-znaleziono',
          en: '/nie-znaleziono',
        },
        title: 'competence.app.routingConfig.notFound.title',
        secured: false,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.OfwcaCertificatePath]: {
        urls: {
          pl: '/certyfikaty/:id',
          en: '/certificates/:id',
        },
        title: 'toyota.app.routingConfig.ofwcaCertificatePath.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCertificatePathDetails,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.OfwcaPathForm]: {
        urls: {
          pl: '/ofwca-path',
          en: '/ofwca-path',
        },
        title: 'toyota.app.routingConfig.ofwcaPathForm.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiOfwcaDashboard,
        ],
        roleVisibilityMode: 'forUse',
      },
    },
  },
  [RouteGroupName.Certificates]: {
    urls: {
      pl: '/certyfikaty',
      en: '/certificates',
    },
    children: {
      [RouteNameEnum.Certificates]: {
        urls: {
          pl: '/',
          en: '/',
        },
        title: 'competence.app.routingConfig.certificates.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCertificateList,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.CertificatePath]: {
        urls: {
          pl: '/:id',
          en: '/:id',
        },
        title: 'competence.app.routingConfig.certificatePath.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCertificatePathDetails,
        ],
        roleVisibilityMode: 'forUse',
      },
    },
  },
  [RouteGroupName.Competences]: {
    urls: {
      pl: '/competence',
      en: '/competence',
    },
    children: {
      [RouteNameEnum.Competences]: {
        urls: {
          pl: '/list',
          en: '/list',
        },
        title: 'competence.app.routingConfig.competences.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCompetenceList,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.CompetenceEntry]: {
        urls: {
          pl: '/:id/:tab',
          en: '/:id/:tab',
        },
        title: 'competence.app.routingConfig.competenceEntry.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCompetenceList,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.CompetenceSelfMarkSurvey]: {
        urls: {
          pl: '/:id/self-mark/:measureId',
          en: '/:id/self-mark/:measureId',
        },
        title: 'competence.app.routingConfig.competenceSelfMarkSurvey.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCompetenceList,
        ],
        roleVisibilityMode: 'forUse',
      },
    },
  },
  [RouteGroupName.Gamification]: {
    urls: {
      pl: '/gamification',
      en: '/gamification',
    },
    children: {
      [RouteNameEnum.GamificationInit]: {
        urls: {
          pl: '/init',
          en: '/init',
        },
        title: 'competence.app.routingConfig.gamificationInit.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiGamificationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.GamificationStart]: {
        urls: {
          pl: '/start',
          en: '/start',
        },
        title: 'competence.app.routingConfig.gamificationStart.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiGamificationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.GamificationSurvey]: {
        urls: {
          pl: '/survey/:id',
          en: '/survey/:id',
        },
        title: 'competence.app.routingConfig.gamificationSurvey.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiGamificationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.GamificationTask]: {
        urls: {
          pl: '/task/:id',
          en: '/task/:id',
        },
        title: 'competence.app.routingConfig.gamificationTask.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiGamificationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.GamificationNews]: {
        urls: {
          pl: '/news/:id',
          en: '/news/:id',
        },
        title: 'competence.app.routingConfig.gamificationNews.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiGamificationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.GamificationPoints]: {
        urls: {
          pl: '/points',
          en: '/points',
        },
        title: 'competence.app.routingConfig.gamificationPoints.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiGamificationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
    },
  },
  [RouteGroupName.News]: {
    urls: {
      pl: '/news',
      en: '/news',
    },
    children: {
      [RouteNameEnum.News]: {
        urls: {
          pl: '/',
          en: '/',
        },
        title: 'competence.app.routingConfig.news.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiNews,
          FunctionalityEnum.ApiNewsList,
          FunctionalityEnum.ApiNewsRead,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.NewsEntry]: {
        urls: {
          pl: '/:id',
          en: '/:id',
        },
        title: 'competence.app.routingConfig.newsEntry.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiNews,
          FunctionalityEnum.ApiNewsRead,
        ],
        roleVisibilityMode: 'forUse',
      },
    },
  },
  [RouteGroupName.Profile]: {
    urls: {
      pl: '/profil',
      en: '/profile',
    },
    children: {
      [RouteNameEnum.ProfileDetails]: {
        urls: {
          pl: '/details',
          en: '/details',
        },
        title: 'competence.app.routingConfig.profileDetails.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProfileRead,
          FunctionalityEnum.ApiUserExperiences,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProfileEdit]: {
        urls: {
          pl: '/edit',
          en: '/edit',
        },
        title: 'competence.app.routingConfig.profileEdit.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProfileRead,
          FunctionalityEnum.ApiProfileReadForm,
          FunctionalityEnum.ApiProfileUpdate,
          FunctionalityEnum.ApiBrands,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProfileAgreementsAndCookies]: {
        urls: {
          pl: '/agreementsAndCookies',
          en: '/agreementsAndCookies',
        },
        title: 'competence.app.routingConfig.profileAgreementsAndCookies.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProfileRead,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProfileAgreements]: {
        urls: {
          pl: '/agreements',
          en: '/agreements',
        },
        title: 'competence.app.routingConfig.profileAgreements.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProfileRead,
          FunctionalityEnum.ApiAgreementUpdate,
          FunctionalityEnum.ApiAgreementList,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProfileCookies]: {
        urls: {
          pl: '/cookies',
          en: '/cookies',
        },
        title: 'competence.app.routingConfig.profileCookies.title',
        secured: true,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProfilePasswords]: {
        urls: {
          pl: '/pass',
          en: '/pass',
        },
        title: 'competence.app.routingConfig.profilePasswords.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUserUpdatePassword,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProfileDocuments]: {
        urls: {
          pl: '/documents',
          en: '/documents',
        },
        title: 'competence.app.routingConfig.profileDocuments.title',
        secured: true,
        requiredFunctionalities: [],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProfileFacsimile]: {
        urls: {
          pl: '/facsimile',
          en: '/facsimile',
        },
        title: 'competence.app.routingConfig.profileFacsimile.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProfileFacsimileDownload,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProfileArchives]: {
        urls: {
          pl: '/archiwum',
          en: '/archive',
        },
        title: 'competence.app.routingConfig.profileArchive.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiDocumentArchiveDocumentsList,
          FunctionalityEnum.ApiDocumentArchiveDocumentDownload,
          FunctionalityEnum.ApiDocumentArchiveDocumentDelete,
        ],
        roleVisibilityMode: 'forAll',
      },
    },
  },
  [RouteGroupName.Substitutions]: {
    urls: {
      pl: '/zastepstwa',
      en: '/substitutions',
    },
    children: {
      [RouteNameEnum.SubstitutionCreate]: {
        urls: {
          pl: '/nowe',
          en: '/nowe',
        },
        title: 'competence.app.routingConfig.substitutionCreate.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiSubstitutions,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.SubstitutionsDashboard]: {
        urls: {
          pl: '/',
          en: '/',
        },
        title: 'competence.app.routingConfig.substitutionsDashboard.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiSubstitutions,
          FunctionalityEnum.ApiSubstitutionsList,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.SubstitutionsList]: {
        urls: {
          pl: '/lista/:viewType',
          en: '/lista/:viewType',
        },
        title: 'competence.app.routingConfig.substitutionsList.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiSubstitutions,
          FunctionalityEnum.ApiSubstitutionsList,
        ],
        roleVisibilityMode: 'forAll',
      },
    },
  },
  [RouteGroupName.TeamIndicators]: {
    urls: {
      pl: '/indicators',
      en: '/indicators',
    },
    children: {
      [RouteNameEnum.TeamIndicatorsStrategic]: {
        urls: {
          pl: '/strategic',
          en: '/strategic',
        },
        title: 'competence.app.routingConfig.teamIndicatorsStrategic.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCompetencePopulationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.TeamIndicatorsCommon]: {
        urls: {
          pl: '/common',
          en: '/common',
        },
        title: 'competence.app.routingConfig.teamIndicatorsCommon.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCompetencePopulationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.TeamIndicatorsStatistics]: {
        urls: {
          pl: '/statistics',
          en: '/statistics',
        },
        title: 'competence.app.routingConfig.teamIndicatorsStatistics.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiCompetencePopulationRead,
        ],
        roleVisibilityMode: 'forUse',
      },
    },
  },
  [RouteGroupName.UsersAdministration]: {
    urls: {
      pl: '/zarzadzanie',
      en: '/users-management',
    },
    children: {
      [RouteNameEnum.UsersAdministrationCompaniesList]: {
        urls: {
          pl: '/firmy',
          en: '/companies',
        },
        title: 'competence.app.routingConfig.usersAdministrationCompaniesList.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUsersAdministrationCompanyList,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.UsersAdministrationDashboard]: {
        urls: {
          pl: '/dashboard',
          en: '/dashboard',
        },
        title: 'competence.app.routingConfig.usersAdministrationDashboard.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUsersAdministrationCompanyList,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.UsersAdministrationUserDetails]: {
        urls: {
          pl: '/uzytkownicy/:id',
          en: '/uzytkownicy/:id',
        },
        title: 'competence.app.routingConfig.usersAdministrationUserDetails.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUsersAdministrationUserDetails,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.UsersAdministrationUsersList]: {
        urls: {
          pl: '/firmy/:id/uzytkownicy',
          en: '/companies/:id/uzytkownicy',
        },
        title: 'competence.app.routingConfig.usersAdministrationUsersList.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUsersAdministrationUsersList,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.UsersAdministrationCompanyDashboard]: {
        urls: {
          pl: '/firmy/:id',
          en: '/companies/:id',
        },
        title: 'competence.app.routingConfig.usersAdministrationCompanyDashboard.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUsersAdministrationUsersList,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.UsersAdministrationCyclicalLessons]: {
        urls: {
          pl: '/firmy/:id/lekcje-cykliczne',
          en: '/companies/:id/cyclical-lessons',
        },
        title: 'competence.app.routingConfig.usersAdministrationCyclicalLessons.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUsersAdministrationCyclicalLessonsList,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.UsersAdministrationCourses]: {
        urls: {
          pl: '/firmy/:id/szkolenia',
          en: '/companies/:id/courses',
        },
        title: 'competence.app.routingConfig.usersAdministrationCourses.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUsersAdministrationCoursesList,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.UsersAdministrationUsersPendingOffboardingList]: {
        urls: {
          pl: '/zgloszenia-offboarding',
          en: '/offboarding-requests',
        },
        title: 'toyota.app.routingConfig.usersAdministrationUsersPendingOffboardingList.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUsersAdministrationDeactivationList,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.UsersAdministrationUserWithOfwcaPathDetails]: {
        urls: {
          pl: '/firmy/:companyId/sciezki-ofwca/:id',
          en: '/companies/:companyId/ofwca-paths/:id',
        },
        title: 'toyota.app.routingConfig.usersAdministrationUserWithOfwcaPathDetails.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiUsersAdministrationUserPathRequestDetails,
        ],
        roleVisibilityMode: 'forAdministration',
      },
    },
  },
  [RouteGroupName.Reports]: {
    urls: {
      pl: '/raporty',
      en: '/reports',
    },
    children: {
      [RouteNameEnum.ReportsDashboard]: {
        urls: {
          pl: '/',
          en: '/',
        },
        title: 'toyota.app.routingConfig.reportsDashboard.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiReportsContract,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.ReportEdit]: {
        urls: {
          pl: '/:id',
          en: '/:id',
        },
        title: 'toyota.app.routingConfig.reportEdit.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiReportsContract,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.NewReport]: {
        urls: {
          pl: '/nowy',
          en: '/new',
        },
        title: 'toyota.app.routingConfig.newReport.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiReportsContract,
        ],
        roleVisibilityMode: 'forAdministration',
      },
    },
  },
  [RouteGroupName.Contracts]: {
    urls: {
      pl: '/umowy',
      en: '/contracts',
    },
    children: {
      [RouteNameEnum.Contracts]: {
        urls: {
          pl: '/',
          en: '/',
        },
        title: 'toyota.app.routingConfig.contracts.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiContractsMy,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.ContractsEditData]: {
        urls: {
          pl: '/wypelnij',
          en: '/complete',
        },
        title: 'toyota.app.routingConfig.contractsEditData.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiContractsMy,
          FunctionalityEnum.ApiFormsTypedSave,
          FunctionalityEnum.ApiFormsTypedGet,
          FunctionalityEnum.ApiFormsDocumentsList,
          FunctionalityEnum.ApiFormsFinish,
          FunctionalityEnum.ApiFormsTokenGenerateSignatureVerification,
          FunctionalityEnum.ApiFormsTokenVerify,
          FunctionalityEnum.ApiFormsUpload,
        ],
        roleVisibilityMode: 'forUse',
      },
    },
  },
  [RouteGroupName.Provisions]: {
    urls: {
      pl: '/provisions',
      en: '/provisions',
    },
    children: {
      [RouteNameEnum.ProvisionsIntro]: {
        urls: {
          pl: '/',
          en: '/',
        },
        title: '',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProvision,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProvisionsAdministratorDashboard]: {
        urls: {
          pl: '/administrator-dashboard',
          en: '/administrator-dashboard',
        },
        title: 'toyota.app.routingConfig.provisionsAdministratorDashboard.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProvision,
          FunctionalityEnum.ApiProvisionImport,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.ProvisionsAdminOfwcaDashboard]: {
        urls: {
          pl: '/admin-ofwca-dashboard',
          en: '/admin-ofwca-dashboard',
        },
        title: 'toyota.app.routingConfig.provisionsAdminOfwcaDashboard.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProvision,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.ProvisionsAddComplaint]: {
        urls: {
          pl: '/complaints/add',
          en: '/complaints/add',
        },
        title: 'toyota.app.routingConfig.provisionsAddComplaint.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProvision,
          FunctionalityEnum.ApiComplaintCreate,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.ProvisionsComplaintDetails]: {
        urls: {
          pl: '/complaints/:id',
          en: '/complaints/:id',
        },
        title: 'toyota.app.routingConfig.provisionsComplaintDetails.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProvision,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProvisionsComplaintsList]: {
        urls: {
          pl: '/complaints-list/:type',
          en: '/complaints-list/:type',
        },
        title: 'toyota.app.routingConfig.provisionsComplaintsList.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProvision,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.ProvisionsContract]: {
        urls: {
          pl: '/sheets/:sheetId/contracts/:contractId',
          en: '/sheets/:sheetId/contracts/:contractId',
        },
        title: 'toyota.app.routingConfig.provisionsContract.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProvision,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.ProvisionsSheet]: {
        urls: {
          pl: '/sheets/:sheetId',
          en: '/sheets/:sheetId',
        },
        title: 'toyota.app.routingConfig.provisionsSheet.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProvision,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.ProvisionsSheets]: {
        urls: {
          pl: '/sheets',
          en: '/sheets',
        },
        title: 'toyota.app.routingConfig.provisionsSheets.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProvision,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.ProvisionsUserDashboard]: {
        urls: {
          pl: '/user-dashboard',
          en: '/user-dashboard',
        },
        title: 'toyota.app.routingConfig.provisionsUserDashboard.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProvision,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.ProvisionsUserMonthSheet]: {
        urls: {
          pl: '/user-sheets/:year/:month',
          en: '/user-sheets/:year/:month',
        },
        title: 'toyota.app.routingConfig.provisionsUserMonthSheet.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProvision,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.ProvisionsUserMonthSheets]: {
        urls: {
          pl: '/user-sheets',
          en: '/user-sheets',
        },
        title: 'toyota.app.routingConfig.provisionsUserMonthSheets.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProvision,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.ProvisionsUserWithoutDocuments]: {
        urls: {
          pl: '/users-without-docs/:id',
          en: '/users-without-docs/:id',
        },
        title: 'toyota.app.routingConfig.provisionsUserWithoutDocuments.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiProvision,
        ],
        roleVisibilityMode: 'forAdministration',
      },
    },
  },
  [RouteGroupName.PathRequests]: {
    urls: {
      pl: '/zgloszenia-do-sciezek',
      en: '/path-requests',
    },
    children: {
      [RouteNameEnum.PathRequestsList]: {
        urls: {
          pl: '/lista',
          en: '/list',
        },
        title: 'toyota.app.routingConfig.pathRequestsList.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiPathRequestAdminList,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.UserPathRequests]: {
        urls: {
          pl: '/twoje-zgloszenia',
          en: '/your-requests',
        },
        title: 'toyota.app.routingConfig.userPathRequests.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiPathRequestUserList,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.UserPathRequestPaperDocumentsList]: {
        urls: {
          pl: '/twoje-zgloszenia/:id/dokumenty-do-wyslania',
          en: '/your-requests/:id/documents-to-send',
        },
        title: 'toyota.app.routingConfig.userPathRequestPaperDocumentsList.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiPathRequestUserList,
          FunctionalityEnum.ApiPathRequestPaperDocumentList,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.PathRequest]: {
        urls: {
          pl: '/:id',
          en: '/:id',
        },
        title: 'toyota.app.routingConfig.pathRequest.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiPathRequestAdminDetails,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.PathRequestDocumentsUpload]: {
        urls: {
          pl: '/:id/wgrywanie-dokumentow/:formAttemptId',
          en: '/:id/documents-upload/:formAttemptId',
        },
        title: 'toyota.app.routingConfig.pathRequestDocumentsUpload.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiPathRequestUserList,
        ],
        roleVisibilityMode: 'forUse',
      },
      [RouteNameEnum.PathRequestDocumentsUploadVerification]: {
        urls: {
          pl: '/:id/weryfikacja-wgrywanych-dokumentow/:formAttemptId',
          en: '/:id/documents-upload-verification/:formAttemptId',
        },
        title: 'toyota.app.routingConfig.pathRequestDocumentsUploadVerification.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiPathRequestAdminDetails,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.PathRequestHistory]: {
        urls: {
          pl: '/:id/historia',
          en: '/:id/history',
        },
        title: 'toyota.app.routingConfig.pathRequestHistory.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiPathRequestAdminDetails,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.PathRequestPaperDocumentsVerification]: {
        urls: {
          pl: '/:id/weryfikacja-dokumentow-papierowych',
          en: '/:id/paper-documents-verification',
        },
        title: 'toyota.app.routingConfig.pathRequestPaperDocumentsVerification.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiPathRequestAdminDetails,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.PathRequestExamEnrollmentEdit]: {
        urls: {
          pl: '/:id/edycja-zapisu-na-egzamin',
          en: '/:id/exam-enrollment-edit',
        },
        title: 'toyota.app.routingConfig.pathRequestExamEnrollmentEdit.title',
        secured: true,
        requiredFunctionalities: {
          operator: 'or',
          functionalities: [
            [
              FunctionalityEnum.ApiPathRequestAdminDetails,
              FunctionalityEnum.ApiPathRequestsEventsDisenrollUser,
              FunctionalityEnum.ApiPathRequestsEventsEnrollUser,
              FunctionalityEnum.ApiPathRequestsUserEventsList,
            ],
            [
              FunctionalityEnum.ApiPathRequestUserList,
              FunctionalityEnum.ApiPathRequestsEventsDisenrollSelf,
              FunctionalityEnum.ApiPathRequestsEventsEnrollSelf,
              FunctionalityEnum.ApiPathRequestsSelfEventsList,
            ],
          ],
        },
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.PathRequestsExamsToProcessList]: {
        urls: {
          pl: '/obsluga-egzaminow',
          en: '/exams-processing',
        },
        title: 'toyota.app.routingConfig.pathRequestsExamsToProcessList.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiPathRequestsEventsMarkAttendance,
          FunctionalityEnum.ApiPathRequestsEventsMarkResults,
          FunctionalityEnum.ApiPathRequestsEventsUploadCertificate,
          FunctionalityEnum.ApiPathRequestsEventsImportAttendance,
          FunctionalityEnum.ApiPathRequestsEventsAdminList,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.PathRequestKnfPermissionsEdit]: {
        urls: {
          pl: '/:id/edycja-uprawnien-knf',
          en: '/:id/knf-permissions-edit',
        },
        title: 'toyota.app.routingConfig.pathRequestKnfPermissionsEdit.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiPathRequestAdminDetails,
        ],
        roleVisibilityMode: 'forAdministration',
      },
      [RouteNameEnum.PathRequestRequiredContentList]: {
        urls: {
          pl: '/:id/wymagane-tresci',
          en: '/:id/required-content-list',
        },
        title: 'toyota.app.routingConfig.pathRequestRequiredContentList.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiPathRequestUserList,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.PathRequestDocumentsDownload]: {
        urls: {
          pl: '/:id/pobieranie-dokumentow',
          en: '/:id/documents-download',
        },
        title: 'toyota.app.routingConfig.pathRequestDocumentsDownload.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiPathRequestUserList,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.PathRequestExamResultsEdit]: {
        urls: {
          pl: '/obsluga-egzaminow/:id',
          en: '/exams-processing/:id',
        },
        title: 'toyota.app.routingConfig.pathRequestExamResultsEdit.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiPathRequestsEventsUploadCertificate,
          FunctionalityEnum.ApiPathRequestsEventsMarkResults,
          FunctionalityEnum.ApiPathRequestsEventsImportAttendance,
          FunctionalityEnum.ApiPathRequestsEventsMarkAttendance,
          FunctionalityEnum.ApiPathRequestsEventsAdminList,
        ],
        roleVisibilityMode: 'forAdministration',
      },
    },
  },
  [RouteGroupName.LegalForms]: {
    urls: {
      pl: '/dokumenty-formalne',
      en: '/legal-forms',
    },
    children: {
      [RouteNameEnum.LegalFormEdit]: {
        urls: {
          pl: '/:id',
          en: '/:id',
        },
        title: 'competence.app.routingConfig.legalFormEdit.title',
        secured: true,
        requiredFunctionalities: [
          FunctionalityEnum.ApiLegalForms,
        ],
        roleVisibilityMode: 'forAll',
      },
      [RouteNameEnum.LegalFormsAttemptsList]: {
        urls: {
          pl: '/weryfikacja/:type',
          en: '/verification/:type',
        },
        title: 'competence.app.routingConfig.legalFormsAttemptsList.title',
        secured: true,
        requiredFunctionalities: [
        ],
        roleVisibilityMode: 'forAdministration',
      },
    },
  },
} satisfies Record<RouteGroupName, RouteGroup>;
